import yup from '../../../config/yup';

export const peoplesoftReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('peoplesoftReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    paginationType: yup.string().oneOf(['QueryString', 'RequestBody', 'Stream']),
    token: yup.string(),
    url: yup.string(),
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    acceptInvalidCerts: yup.boolean(),
    headerJson: yup.string(),
    body: yup.string(),
    queryString: yup.string(),
  }),
});
